import { Card, CardContent, CardTitle } from "@/components/ui/card";
import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from "recharts";
import { useEffect, useState } from "react";
import axiosInstance from "@/utils/axiosInstance";

const chartConfig = {
  count: {
    label: "Count",
    color: "var(--text-foreground)",
  },
} satisfies ChartConfig;

const TotalOrders = ({
  range,
}: {
  range: { startDate: Date; endDate: Date };
}) => {
  const [chartData, setChartData] = useState<{count: number, month: string}[]>([]);

  useEffect(() => {
    const getOrders = async () => {
      const { data } = await axiosInstance.get<{count: string, month: string}[]>("/reports/commission-orders", {
        params: {
          startDate: range.startDate.toISOString().split("T")[0],
          endDate: range.endDate.toISOString().split("T")[0],
        },
      });

      const newChartData: {count: number, month: string}[] = data.map((item) => ({
        count: +item.count,
        month: item.month,
      }));

      setChartData(newChartData);
    };

    getOrders();
  }, [range]);

  return (
    <Card className="max-w-full">
      <CardContent>
        <CardTitle>Total orders</CardTitle>

        <ChartContainer config={chartConfig} className="min-h-[200px] w-full">
          <BarChart accessibilityLayer data={chartData} margin={{left: -20, top: 20, bottom: -10}}>
            <ChartTooltip content={<ChartTooltipContent nameKey="count" />} />
            <CartesianGrid
              strokeDasharray="3 3" // makes stripes dotted
              vertical={false} // only horizontal stripes
              stroke="#e5e7eb" // light gray color
            />

            {/* 2. Place axes BEFORE bars so they stay behind */}
            <XAxis
              dataKey="month"
              orientation="bottom"
              tick={{ fontSize: 12 }}
              axisLine={false} // optional: hide main line
              tickLine={false} // optional: hide small ticks
            />

            <YAxis
              dataKey="count"
              tick={{ fontSize: 12 }}
              axisLine={false}
              tickLine={false}
            />
            <Bar dataKey="count" fill="var(--color-count)" radius={4} />
          </BarChart>
        </ChartContainer>
      </CardContent>
    </Card>
  );
};

export default TotalOrders;
